import LocalForage from 'localforage';
import CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';

// console.log('storage, LocalForage.INDEXEDDB=', LocalForage.INDEXEDDB);
// console.log('storage, LocalForage.WEBSQL=', LocalForage.WEBSQL);
// console.log('storage, LocalForage.LOCALSTORAGE=', LocalForage.LOCALSTORAGE);

// module-scoped singleton for LocalForage instance
let dbInstance = null;

// STORAGE_KEY
export const STORAGE_KEY = 'YouEvent365_asm_organizer'; // 要等於 createPersistedState 的 key

/**
 * 遞迴檢查物件是否為空（包含巢狀結構）
 * @param {*} obj - 要檢查的物件
 * @returns {boolean} - 是否為深度空物件
 */
const isDeepEmpty = obj => {
	if (obj === null || obj === undefined) return true;
	if (Array.isArray(obj)) return obj.length === 0;
	if (typeof obj !== 'object') return false;

	const keys = Object.keys(obj);
	if (keys.length === 0) return true;

	// 檢查所有屬性是否都為空
	return keys.every(key => isDeepEmpty(obj[key]));
};

/**
 * 初始化 LocalForage database
 */
const initDB = async () => {
	if (dbInstance) return;

	const config = {
		name: 'YouEvent365_asm', // 要等於 createPersistedState 的 key
		storeName: STORAGE_KEY, // 要等於 createPersistedState 的 key
		driver: [
			CordovaSQLiteDriver._driver,
			LocalForage.INDEXEDDB, // 預設 DB
			LocalForage.WEBSQL,
			LocalForage.LOCALSTORAGE,
		],
		version: 1,
		description: 'YouEvent365 ASM organizer admin storage',
	};

	try {
		// 1. 定義自訂驅動
		await LocalForage.defineDriver(CordovaSQLiteDriver);

		// 2. 建立 instance 並指定 driver 預設順序
		const instance = LocalForage.createInstance(config);

		// 3. 等待 ready 完成
		await instance.ready();

		// 4. 取回目前使用的 driver
		// const usedDriver = instance.driver();
		// console.log('storage, driver=', usedDriver);

		// 你可以拿 usedDriver 去跟 CordovaSQLiteDriver._driver 比對，
		// 或者再用 instance.supports(usedDriver) 確認該 driver 是否真被支援。

		// 5. 儲存 instance
		dbInstance = instance;

		// 6. 取得目前的 quota 和 usage
		const { usage, quota } = await navigator.storage.estimate();
		console.log(`storage, used ${usage} bytes, quota ${quota} bytes`);

		//
	} catch (error) {
		console.error('storage, failed to initialize storage:', error);
	}
};

const get = async key => {
	console.log(`storage, get, key=${key}`);
	if (!dbInstance) {
		console.log(`storage, get, initdb`);
		await initDB();
	}

	// TODO: 取得資料未來加上gzip解密
	const raw = await dbInstance.getItem(key);
	if (!raw) {
		console.log(`storage, get, key=${key}, persist raw is null`);
		return null;
	}

	const json = typeof raw === 'string' ? JSON.parse(raw) : raw;
	console.log(`storage, get, key=${key}, persist raw loaded`);

	const parts = key.split('.'); // ['evt365_dse_attendeee', 'settings']
	const group = parts[parts.length - 1]; // 'settings'
	const groupValue =
		json && typeof json === 'object' && group in json ? json[group] : json;

	console.log(`storage, get, key=${key}, group=${group}, vuex value loaded`);
	return groupValue;
};

/*
 * store/index.js裡 vuex-persistedstate 用 storageAdapter 會
 * 用set, get, remove 方法，不知道為何
 * 1. App 初始化時，會自動呼叫 set 給予 defaultState 物件
 * 2. 每次 mutation 後，自動持久化變更的 state
 * 為避免儲存空物件浪費空間，已加入 isDeepEmpty 檢查
 */
const set = async (key, value) => {
	const parsed = JSON.parse(value);
	console.log('storage, set, key=', key);

	// 檢查 value 是否為空物件（含巢狀檢查）
	if (isDeepEmpty(parsed)) {
		console.log('storage, set, key=', key, ', skip deep empty object');
		return;
	}

	if (!dbInstance) {
		await initDB();
	}

	// TODO: 寫入資料未來加上gzip加密

	// 如果要儲存 Vuex 模組，記得在外層用 JSON.stringify
	return await dbInstance.setItem(
		key,
		typeof value === 'string' ? value : JSON.stringify(value)
	);
};

const remove = async key => {
	// console.log('storage, remove, key=', key);
	if (!dbInstance) {
		await initDB();
	}
	return await dbInstance.removeItem(key);
};

const clear = async () => {
	// console.log('storage, clear');
	if (!dbInstance) {
		await initDB();
	}
	return await dbInstance.clear();
};

export const useStorage = () => ({
	STORAGE_KEY,
	initDB,
	get,
	set,
	remove,
	clear,
});
